import { observer } from 'mobx-react';
import { FC } from 'react';
import { useHistory } from 'react-router-dom';

import { Button, Flex, Icon, Text } from '@servicetitan/anvil2';
import IconArrowBack from '@servicetitan/anvil2/assets/icons/material/round/arrow_back.svg';
import IconClose from '@servicetitan/anvil2/assets/icons/material/round/close.svg';
import IconAtlasLogo from '@servicetitan/anvil2/assets/icons/st/atlas_logo.svg';

import IconInfo from '../icon-info.svg?component';
import * as Styles from './chat-header.module.less';

interface ChatHeaderProps {
    onNavigationButtonClick: () => void;
    icon: 'close' | 'back';
    hideInfoButton?: boolean;
}

export const ChatHeaderNew: FC<ChatHeaderProps> = observer(
    ({ onNavigationButtonClick, icon, hideInfoButton }) => {
        const history = useHistory();

        const handleInfoButtonClick = () => {
            history.push('/readme');
        };

        const showInfoButton = false;
        return (
            <Flex gap="2" className={Styles.chatHeader} direction="row" alignItems="center">
                <Button
                    onClick={onNavigationButtonClick}
                    size="medium"
                    appearance="ghost"
                    icon={icon === 'close' ? IconClose : IconArrowBack}
                />

                <Flex grow="1" justifyContent="center">
                    <Flex direction="row" alignItems="center" gap="2">
                        <Icon svg={IconAtlasLogo} size="large" />
                        <Text variant="headline" className="m-t-half" el="h1" size="large">
                            Atlas
                        </Text>
                    </Flex>
                </Flex>

                {!hideInfoButton && showInfoButton ? (
                    <Button
                        onClick={handleInfoButtonClick}
                        size="medium"
                        appearance="ghost"
                        icon={IconInfo}
                    />
                ) : (
                    <span style={{ width: 40 }} />
                )}
            </Flex>
        );
    }
);
